// extracted by mini-css-extract-plugin
export default {"container":"styles_container__vdspf","frame":"styles_frame__dwquj","loading":"styles_loading__UCfEZ"};